interface Props {
  googleSheetsCode: string;
  eodhdCode: string;
  onGoogleSheetsCodeChange: (value: string) => void;
  onEodhdCodeChange: (value: string) => void;
  disabled: boolean;
}

// The backend only accepts /^[A-Z0-9]+$/, so anything else is dropped while typing.
const sanitizeCode = (value: string) => value.toUpperCase().replace(/[^A-Z0-9]/g, '');

/** Exchange codes used to derive the default Google-Sheets/EODHD refs of new symbols. */
export default function StockExchangeSourceCodeFields({ googleSheetsCode, eodhdCode, onGoogleSheetsCodeChange, onEodhdCodeChange, disabled }: Props) {
  const inputClass = 'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm font-mono focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 dark:bg-gray-700 dark:text-white';

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
      <div>
        <label htmlFor="googleSheetsCode" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Google-Sheets-Code
        </label>
        <input
          type="text"
          id="googleSheetsCode"
          value={googleSheetsCode}
          onChange={(e) => onGoogleSheetsCodeChange(sanitizeCode(e.target.value))}
          className={inputClass}
          placeholder="z.B. ETR"
          disabled={disabled}
          autoComplete="off"
        />
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Börsenkürzel für GOOGLEFINANCE, leer = Identifier
        </p>
      </div>
      <div>
        <label htmlFor="eodhdCode" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          EODHD-Code
        </label>
        <input
          type="text"
          id="eodhdCode"
          value={eodhdCode}
          onChange={(e) => onEodhdCodeChange(sanitizeCode(e.target.value))}
          className={inputClass}
          placeholder="z.B. XETRA"
          disabled={disabled}
          autoComplete="off"
        />
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          EODHD-Börsencode, z. B. US, XETRA, F, LSE, TO
        </p>
      </div>
    </div>
  );
}
